module.exports = __webpack_public_path__ + "img/zxns.22db59da.png";